import type { z } from 'zod';
import type { callingSchema } from '../schema.ts';

export const callings: z.input<typeof callingSchema>[] = [
  {
    id: 'knight', name: 'Knight', icon: 'black-knight-helm',
    affinity: ['jousting', 'horsemanship', 'smithing'],
    perk: { name: 'Chivalry', description: 'Sparing a foe grants double Renown. +5% Defence.' },
    kit: [{ item: 'worn-arming-sword', quantity: 1 }, { item: 'padded-gambeson', quantity: 1 }, { item: 'old-nag', quantity: 1 }],
    bonusCoin: 0,
    fighting: { rating: 'strong', note: 'Sword, padding and a horse from the first day.' },
  },
  {
    id: 'ranger', name: 'Ranger', icon: 'robin-hood-hat',
    affinity: ['archery', 'hunting', 'woodcutting'],
    perk: { name: 'Woodcraft', description: 'Half the chance of being caught poaching. +5% Dexterity.' },
    kit: [{ item: 'short-bow', quantity: 1 }, { item: 'arrow', quantity: 20 }, { item: 'hatchet', quantity: 1 }],
    bonusCoin: 0,
    fighting: { rating: 'strong', note: 'A bow and a hatchet. Keep arrows in your quiver.' },
  },
  {
    id: 'rogue', name: 'Rogue', icon: 'hooded-assassin',
    affinity: ['lockpicking', 'cardSharping', 'gambling'],
    perk: { name: 'Light Fingers', description: 'Gaol time −25%. Robbing takes 3% more.' },
    kit: [{ item: 'bent-pick-set', quantity: 1 }, { item: 'marked-deck', quantity: 1 }, { item: 'dagger', quantity: 1 }],
    bonusCoin: 0,
    fighting: { rating: 'fair', note: 'A quick dagger: better for robbing than brawling.' },
  },
  {
    id: 'artisan', name: 'Artisan', icon: 'gear-hammer',
    affinity: ['mining', 'smithing', 'engineering'],
    perk: { name: 'Thrift', description: '10% chance a craft consumes no materials.' },
    kit: [{ item: 'pick', quantity: 1 }, { item: 'hammer', quantity: 1 }, { item: 'tongs', quantity: 1 }],
    bonusCoin: 0,
    fighting: { rating: 'fair', note: 'A smith’s hammer hits hard, and you can forge better.' },
  },
  {
    id: 'cloistered', name: 'Cloistered', icon: 'monk-face',
    affinity: ['illumination', 'alchemy', 'brewing'],
    perk: { name: 'Sanctuary', description: 'Your Infirmary time −25%. Treating others heals 50% more.' },
    kit: [{ item: 'quills', quantity: 1 }, { item: 'mortar-and-pestle', quantity: 1 }, { item: 'healing-draught', quantity: 3 }, { item: 'pilgrims-staff', quantity: 1 }],
    bonusCoin: 0,
    fighting: { rating: 'weak', note: 'Only a pilgrim’s staff. Buy or forge a real weapon before your protection ends.' },
  },
  {
    id: 'merchant', name: 'Merchant', icon: 'shiny-purse',
    affinity: ['haggling', 'fishing', 'horsemanship'],
    perk: { name: 'Trade Licence', description: '2 extra cargo slots on the road. Market fees 4% instead of 5%.' },
    kit: [{ item: 'fishing-rod', quantity: 1 }, { item: 'pack-mule', quantity: 1 }, { item: 'cudgel', quantity: 1 }],
    bonusCoin: 250,
    fighting: { rating: 'weak', note: 'Only a cudgel, but coin to buy better. Do so before your protection ends.' },
  },
];
